

export function TickFormat(value, tz){
    //console.log("yaxis timezone:",tz)
    //converts epoch seconds to epoch miliseconds
    if (value<100000000){
         value = value *1000
    }
    const dateFormat = new Intl.DateTimeFormat('en-US', {
    timeZone: "America/New_York",
    hour:"2-digit",
    minute:"2-digit",
    second:"2-digit"
    });
    let date = new Date(value);
      //  console.log('formatting value into hrf')
      const parts = dateFormat.formatToParts(date)
      console.log("local:",date.toString())
      console.log("tz parts:",parts)
        let minutes = date.getMinutes().toString()
        if (minutes.length==1){
            minutes=0+minutes;
        }
        
        let hours = date.getHours().toString()
        if (hours.length==1){
            hours=0+hours;
        }
        let dateString = hours + ':'+ minutes;
        //console.log(`format Finished dateString = ${dateString}`)
    return dateString
    
   
}
export default TickFormat;